'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReadableOverrideCode = function getReadableOverrideCode(code) {
    if (!code || typeof code !== 'string') return '';

    return code.toLowerCase().split('_').join(' ').replace(/^\w/, function (c) {
        return c.toUpperCase();
    });
};

var OverrideInput = function OverrideInput(_ref) {
    var intl = _ref.intl,
        input = _ref.input,
        requirement = _ref.requirement,
        overrideLabels = _ref.overrideLabels,
        props = (0, _objectWithoutProperties3.default)(_ref, ['intl', 'input', 'requirement', 'overrideLabels']);

    var appliedOverride = requirement.applied_overrides && requirement.applied_overrides[0];
    var overrides = appliedOverride ? _lodash2.default.uniqBy([].concat((0, _toConsumableArray3.default)(requirement.override_reasons), [appliedOverride.reason]), 'id') : requirement.override_reasons;
    var getOverrideLabel = function getOverrideLabel(overrideCode) {
        var message = overrideLabels && overrideLabels[overrideCode];
        return message ? intl.formatMessage(message) : getReadableOverrideCode(overrideCode);
    };

    if (overrides.length === 1) {
        var overrideValue = overrides[0].code;

        var handleChange = function handleChange(event) {
            var isChecked = event.target.checked;
            input.onChange(isChecked ? overrideValue : "");

            if (props.customOnChange) props.customOnChange(isChecked);
        };

        return _react2.default.createElement(_components2.Input, (0, _extends3.default)({}, props, {
            input: (0, _extends3.default)({}, input, {
                checked: input.value === overrideValue,
                onChange: handleChange,
                onBlur: function onBlur() {
                    return input.onBlur(input.value);
                }
            }),
            type: 'checkbox',
            requirement: requirement
        }));
    } else if (overrides.length > 1) {
        return _react2.default.createElement(_components2.Input, (0, _extends3.default)({}, props, {
            input: input,
            type: 'select',
            requirement: requirement,
            options: overrides.map(function (override) {
                return {
                    label: getOverrideLabel(override.code),
                    value: override.code
                };
            })
        }));
    } else {
        return null;
    }
};

OverrideInput.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    input: _propTypes2.default.object.isRequired,
    requirement: _propTypes2.default.object.isRequired,
    overrideLabels: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(OverrideInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/OverrideInput.js
// module id = 1346
// module chunks = 0